import { ADD_GTAG_IDENTIFIERS } from '@/configs/gtag';

type GIdDataType = {
  module: string;
  screen: string;
  section: string;
  component: string;
  disabled?: boolean;
};

function getGid({ module, screen, section, component, disabled }: GIdDataType) {
  return `${module}_${screen}_${section}_${component}${
    disabled ? 'Disabled' : ''
  }`;
}

function setGid({
  el,
  module,
  screen,
  section,
  component,
  disabled,
}: GIdDataType & { el: HTMLElement }) {
  if (ADD_GTAG_IDENTIFIERS) {
    let element: HTMLElement = el;

    if (element.tagName === 'LABEL') {
      element = el.querySelector('input') ?? el;
    }

    const gid = getGid({ module, screen, section, component, disabled });
    element.setAttribute('data-gid', gid);
  }
}

export default {
  mounted(el: HTMLElement, { value }: { value: GIdDataType | undefined }) {
    if (value) {
      const { module, screen, section, component, disabled } = value;
      setGid({ el, module, screen, section, component, disabled });
    }
  },
  updated(el: HTMLElement, { value }: { value: GIdDataType | undefined }) {
    if (value) {
      const { module, screen, section, component, disabled } = value;
      setGid({ el, module, screen, section, component, disabled });
    }
  },
};
